<template>
    <span @click="$emit('click')" :class="'favourite-state js-favourite-state'+ (active ? ' active' : '') "
          :title="getTitle">
                    <icon-base v-show="!loading" width="20" height="19" viewBox="0 0 20 19" fill="transparent" :icon-name="getTitle"><icon-star/></icon-base>
                    <icon-spinner v-if="loading" width="20" height="19"></icon-spinner>
    </span>
</template>

<script>
    import IconBase from "./IconBase";
    import IconSpinner from "./icons/IconSpinner";
    import IconStar from "./icons/IconStar";
    export default {
        name: 'favorite-switcher',
        components: {IconStar, IconSpinner, IconBase},
        props: {
            loading: Boolean,
            active: Boolean
        },
        computed: {
            getTitle() {
                return this.active ? 'Удалить из избранного' : 'Добавить в избранное'
            }
        }
    }
</script>

<style scoped>

</style>
